/* Total Eyewear — rx-index-gate.js (v2, 7 Jul 2026)
 * For Supra / Semi-rimless / Rimless (drill-mount) frames only
 * (window.TE_FRAME_BUILD set by layout/theme.liquid from
 * product.metafields.custom.frame_build): hides the Standard (1.5) lens tier
 * in the Rx wizard and blocks its selection, because grooved (supra /
 * semi-rimless) and drilled (rimless) glazing needs a stronger high-index
 * material (1.6+) — thin low-index (CR-39) lenses crack in these mounts.
 * Full-rim frames (metafield absent or "Full-rim"): this script does nothing.
 * v2: match is now tolerant of naming variants (supra, semi-rim(less),
 *     nylor, rimless, drill/drilled/drill-mount) so a semi-rimless frame
 *     reliably triggers the high-index lock (Daneev 7 Jul 2026).
 * Follows the same external-guard pattern as rx-tint-guard.js / rx-select-guard.js.
 */
(function () {
  'use strict';
  var build = (window.TE_FRAME_BUILD || '').toString().toLowerCase();
  /* Any grooved or drilled construction => high-index only. Full-rim never matches. */
  var HIGH_INDEX_ONLY = /supra|semi.?rim|nylor|rimless|drill/.test(build) &&
                        !/full.?rim/.test(build);
  if (!HIGH_INDEX_ONLY) return;

  var RE_15 = /\(1\.5\)/; /* matches the "Standard (1.5)" tier card label */
  var NOTE_ID = 'te-index-gate-note';

  function is15Card(el) {
    var card = el && el.closest ? el.closest('.rx-tier') : null;
    return card && RE_15.test(card.textContent || '') ? card : null;
  }

  /* Block selection at capture phase so the wizard's own handlers never fire */
  ['click', 'keydown'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (evt === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      if (is15Card(e.target)) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  });

  function sweep() {
    var cards = document.querySelectorAll('.rx-tier');
    if (!cards.length) return;
    var hidAny = false;
    cards.forEach(function (card) {
      if (RE_15.test(card.textContent || '') && card.style.display !== 'none') {
        card.style.display = 'none';
        card.setAttribute('aria-hidden', 'true');
        card.setAttribute('tabindex', '-1');
        hidAny = true;
      }
    });
    if (hidAny && !document.getElementById(NOTE_ID)) {
      var first = document.querySelector('.rx-tier');
      var host = first && first.parentElement;
      if (host) {
        var note = document.createElement('p');
        note.id = NOTE_ID;
        note.style.cssText = 'margin:6px 0 0;font-size:0.78rem;color:#556;';
        note.textContent = 'This frame’s construction needs a stronger, thinner lens material — so we only offer our Thin & Light (1.6) lenses and above.';
        host.appendChild(note);
      }
    }
  }

  var mo = new MutationObserver(sweep);
  function start() {
    sweep();
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
